// Mahjong: the shape the player picked in the Games window (owner 2026-10-27), or none: a new deal then takes a shape
// that fits the board at random. Kept in the browser (a won game reloads the page, so memory would lose it).
import { MAHJONG_LAYOUTS } from '../engine/rules/mahjong';

// renamed from mahjong-layout on 2026-10-27: the picks made while the owner tried the prototypes are forgotten
const KEY = 'solitaire_storage:mahjong-shape';

/** The picked layout (an index of MAHJONG_LAYOUTS), or null for a random one. */
export function pickedMahjongLayout(): number | null {
  try {
    const v = localStorage.getItem(KEY);
    const n = v === null ? NaN : Number(v);
    return MAHJONG_LAYOUTS[n] ? n : null;
  } catch {
    return null;
  }
}

export function pickMahjongLayout(layout: number | null): void {
  try {
    if (layout === null) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, String(layout));
  } catch {
    // no storage (a private window): the pick lasts until the page reloads
  }
}
